import { css } from 'lit';

export const baseStyles = [
  css`
    :where(.player-container) {
      display: block;
      inline-size: 100%;
    }
  `,
];
